import { Injectable, inject } from '@angular/core';
import { GraphQLClient } from '../graphql/client';
import {
    BrandChangeActivityResult,
    GetBrandChangeActivityResponse,
    TEMPORAL_QUERIES,
} from '../graphql/temporal-operations';

/**
 * Client lane for the brandChangeActivity query: the Time-travel panel's density-strip read.
 * Thin by design — the panel owns the five-state chain and the degrade
 * (strip failure → picker-only), so errors propagate untouched and nothing toasts here.
 */
@Injectable({ providedIn: 'root' })
export class TemporalActivityService {
    private readonly graphql = inject(GraphQLClient);

    async getBrandChangeActivity(): Promise<BrandChangeActivityResult> {
        const response = await this.graphql.queryAsync<GetBrandChangeActivityResponse>(
            TEMPORAL_QUERIES.GET_BRAND_CHANGE_ACTIVITY,
        );
        return response.brandChangeActivity;
    }
}
